import { useEffect } from 'react';

export const useEscapeFix = (setProperty: (value: boolean) => void) => {
  useEffect(() => {
    const onEscKeyPressed = (event: any) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setProperty(false);
      }
    };

    document.addEventListener('keydown', onEscKeyPressed);

    return () => {
      document.removeEventListener('keydown', onEscKeyPressed);
    };
  }, []);
};
